$(document).ready(function(){
    setTimeout(function(){
        $('.right_buttons a.btn[href="#enquire_now"]').click(function(){
            $('.klaviyo-form-XiymyZ').addClass('act');
        });
        $('.klaviyo-form-XiymyZ.klaviyo-form form.needsclick.klaviyo-form , div#wizard-validation-form form').append(
            '<span class="close-pop"><img src="https://cdn.shopify.com/s/files/1/0792/3187/7442/files/close.png?v=1762149201"></span>'
        );
        $('.klaviyo-form-XiymyZ.klaviyo-form form.needsclick.klaviyo-form .close-pop').click(function(){
            $('.klaviyo-form-XiymyZ').removeClass('act');
        });
    }, 500);
});


$(document).ready(function(){
    setTimeout(function(){
        $('a.nt_btn[href="#enquire"]').click(function(){
            $('div#wizard-validation-form').addClass('act');
        });
        $('div#wizard-validation-form form .close-pop').click(function(){
            $('div#wizard-validation-form').removeClass('act');
        });
    }, 500);
});

$(document).ready(function(){
    $('.cstm-home-tab-cont a[href="https://w.abacus.co/Store/2207923?_ga=2.162635705.48316945.1690776524-1119551427.1690171158"]').attr('target' , '_blank');
});
$(document).ready(function(){
    setTimeout(function(){
        $('div.section-header header.header.page-width nav.header__inline-menu>ul.list-menu>li:first-child>ul.mm-submenu > li[aria-label="By Range"]').hover(function(){
            $('div.section-header header.header.page-width nav.header__inline-menu>ul.list-menu>li:first-child').toggleClass('by_range');
        });
    }, 500);
    $('ul#product-grid li.grid__item a[href="/products/gift-free-product-20"]').closest('li.grid__item').addClass('free_gft');
});
$(document).ready(function(){
    setTimeout(function(){
        $('div.section-header header.header.page-width nav.header__inline-menu > ul.list-menu > li').hover(function(){
            $(this).addClass('sh_cus').siblings().removeClass('sh_cus');
        });
    }, 500);
});